/*
 * @Description: 
 * @Autor: lkz
 * @Date: 2021-04-19 18:50:12
 * @LastEditors: lkz
 * @LastEditTime: 2021-05-13 15:00:34
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/knowledgeBase',
    name: '/knowledgeBase',
    meta: {
      title: '知识库管理'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/index.vue')
  },
  {
    path: '/knowledgeBase/knowledgeList',
    name: '/knowledgeList',
    meta: {
      title: '知识库列表'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/knowledgeList')
  },
  {
    path: '/knowledgeBase/itemKnowledgeList',
    name: '/itemKnowledgeList',
    meta: {
      title: '知识库列表'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/ItemKnowledge/ItemKnowledgeList')
  },
  {
    path: '/knowledgeBase/knowledgeDetail',
    name: '/knowledgeDetail',
    meta: {
      title: '知识库详情'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/knowledgeDetail')
  },
  {
    path: '/knowledgeBase/itemKnowledgeDetail',
    name: '/ItemKnowledgeDetail',
    meta: {
      title: '知识库详情'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/ItemKnowledge/KnowledgeDetail')
  },
  {
    path: '/knowledgeBase/knowledgeAdd',
    name: '/knowledgeAdd',
    meta: {
      title: '新增知识点'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/knowledgeAdd')
  },
  {
    path: '/knowledgeBase/knowledgeSearch',
    name: '/knowledgeSearch',
    meta: {
      title: '客服知识库'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/knowledgeSearch')
  },
  {
    path: '/knowledgeBase/publicAdmins/publicAdmin',
    name: '/publicAdmin',
    meta: {
      title: '公告管理'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/publicAdmins/publicAdmin')
  },
  {
    path: '/knowledgeBase/salesRobot',
    name: '/salesRobot',
    meta: {
      title: '售前机器人'
    },
    component: () =>
      import( /* webpackChunkName: "example-knowledgeBase" */ '../views/knowledgeBase/salesRobot')
  }
]
